import * as yup from 'yup';
export var StudentEligibilityModalSchema = yup.object().shape({
    preferredCourse: yup.array().of(yup.string()).nullable(),
    englishGrades: yup.number().typeError('Only positive numbers are allowed').min(0).nullable().required(),
    overallGrades: yup.string().optional().nullable(),
    studentAcademicPreference: yup.string().optional().nullable(),
    englishExamType: yup.string().optional().nullable(),
    englishExamTotalScore: yup.string().optional().nullable(),
    englishExamWritingScore: yup.string().optional().nullable(),
    englishExamReadingScore: yup.string().optional().nullable(),
    englishExamListeningScore: yup.string().optional().nullable(),
    englishExamSpeakingScore: yup.string().optional().nullable(),
    degree: yup.string().optional().nullable(),
    specialization: yup.string().optional().nullable(),
    pgGradingScheme: yup.string().optional().nullable(),
    pgGrades: yup.string().optional().nullable(),
    ugGradingScheme: yup.string().optional().nullable(),
    ugGrades: yup.string().optional().nullable(),
    totalBackLogs: yup.string().optional().nullable(),
    totalYearOfEducation: yup.string().optional().nullable(),
    totalYearsWorkExperience: yup.string().optional().nullable(),
    studentWorkPreference: yup.string().optional().nullable(),
    higherExamType: yup.string().optional().nullable(),
    higherExamTotalScore: yup.string().optional().nullable(),
    status: yup.string().optional().nullable(),
    preferredCountry: yup.object().nullable()
});
//# sourceMappingURL=StudentEligibilityModal.schema.js.map